var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center gap-2 py-4"},[_vm._l((_vm.total),function(n){return [_c('div',{key:n,staticClass:"h-1.5 rounded-full transition-all duration-200",class:n <= _vm.current ? 'bg-black w-8' : 'bg-gray-200 w-8 opacity-60'})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }